/**
 * Security feature grid component
 */

interface SecurityFeature {
  title: string;
  description: string;
}

interface SecurityFeatureGridProps {
  features: SecurityFeature[];
}

export function SecurityFeatureGrid({features}: SecurityFeatureGridProps) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {features.map((feature, index) => (
        <div key={index} className="bg-white dark:bg-[#1E1E1E] border border-gray-200 dark:border-gray-700 rounded-xl p-6 hover:shadow-md transition-all duration-300 hover:-translate-y-1">
          <h4 className="font-semibold text-lg text-gray-900 dark:text-[#CCCCCC] mb-3">{feature.title}</h4>
          <p className="text-sm text-gray-600 dark:text-[#858585] leading-relaxed">{feature.description}</p>
        </div>
      ))}
    </div>
  );
}

